export default __webpack_public_path__ + "static/media/unilever.b951b97b.png";